package music.jammers.shared.event.track.domain.model

import kotlinx.serialization.Serializable
import music.jammers.shared.event.domain.model.EventInstrument

@Serializable
data class UpdateEventTrack(
    val updateMembers: List<EventInstrument>,
    val comment: String,
)